import React from "react";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";

import configureStore from "../VenueManager/store/venueManagerStore";
import SettingsVenueDetails from "./components/SettingsVenueDetails";

const SettingsVenueDetailsApp = (props) => {
  const { settingsPath, lastEditedAt, changelogVersions, ...venueManagerProps } = props;

  return (
    <Provider store={configureStore(venueManagerProps)}>
      <ToastContainer icon={false} />
      <SettingsVenueDetails settingsPath={settingsPath} lastEditedAt={lastEditedAt} changelogVersions={changelogVersions} />
    </Provider>
  );
};

export default SettingsVenueDetailsApp;
